import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = () => {
    return api.get(`/messagedefault/all`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de todas as mensagem padrão')
        })
}

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/messagedefault?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de mensagem padrão')
        })
}

const find = (id) => {
    return api.get(`/messagedefault/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a mensagem padrão')
        })
}

const store = (data) => {
    return api.post(`/messagedefault`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar a mensagem padrão')
        })
}

const update = (data) => {
    return api.put(`/messagedefault/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar a mensagem padrão')
        })
}

const destroy = (id) => {
    return api.delete(`/messagedefault/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir a mensagem padrão')
        })
}

export default {
    all,
    findAll,
    find,
    store,
    update,
    destroy
}
